import { render, staticRenderFns } from "./CardGeneralIndexConsolidated.vue?vue&type=template&id=58f25867&scoped=true&"
import script from "./CardGeneralIndexConsolidated.vue?vue&type=script&lang=js&"
export * from "./CardGeneralIndexConsolidated.vue?vue&type=script&lang=js&"
import style0 from "./CardGeneralIndexConsolidated.vue?vue&type=style&index=0&id=58f25867&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f25867",
  null
  
)

export default component.exports